// @ts-strict-ignore
import * as React from 'react';
import clsx from 'clsx';
import { Alignment, Fit, Layout, RiveState, useRive, useStateMachineInput } from '@rive-app/react-canvas';
import { Button, Typography } from 'onboarding-components';
import { getProjectId, getReportUrl, getWorkspaceId } from 'common/report/util';
import { IMMERSIVE_ASSETS } from 'common/onboarding/immersive-onboarding-legacy/assets';
import { track, TrackingEvent } from 'common/onboarding/immersive-onboarding-legacy/tracking';
import { useTranslation } from 'common/i18n/hooks';
import styles from './index.module.styl';
const openNewTabHandler = (appName: string) => {
  window.open(getReportUrl(appName, {
    projectId: getProjectId(),
    workspaceId: getWorkspaceId()
  }, true /** Ignore Search */), "_blank");
};
const ListeningContent = () => {
  const {
    t
  } = useTranslation();
  return <div className={clsx(styles.content, styles.justifyContentCenter)} data-sentry-component="ListeningContent" data-sentry-source-file="index.tsx">
      <div className={clsx(styles.eventListenerContent, styles.justifyContentCenter)}>
        <Typography className={styles.eventListenerTitle} variant='bodySm' weight='bold' data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {t("onboarding-legacy.implement.listening-for-data")}
        </Typography>
        <Typography className={styles.eventListenerDescription} variant='bodySm' weight='regular' data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {t("onboarding-legacy.implement.no-data-detected")}
        </Typography>
      </div>
    </div>;
};
const ConnectedContent = () => {
  const {
    t
  } = useTranslation();
  return <div className={clsx(styles.content, styles.fadeIn)} data-sentry-component="ConnectedContent" data-sentry-source-file="index.tsx">
      <div className={styles.eventListenerContent}>
        <Typography className={styles.eventListenerTitle} variant='bodySm' weight='bold' data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          <img src={IMMERSIVE_ASSETS.eventDetected} />
          {t("onboarding-legacy.implement.data-detected")}
        </Typography>
        <Typography className={styles.eventListenerDescription} variant='bodySm' weight='regular' data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {t("onboarding-legacy.implement.click-for-details")}
        </Typography>
      </div>
      <div className={styles.eventListenerButtons}>
        <Button onClick={() => {
        track(TrackingEvent.ViewEventsClick);
        openNewTabHandler("events");
      }} variant={"transparent"} size={"small"} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          {t("onboarding-legacy.implement.view-events")}
        </Button>
        <Button onClick={() => {
        track(TrackingEvent.ViewUsersClick);
        openNewTabHandler("users");
      }} variant={"transparent"} size={"small"} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          {t("onboarding-legacy.implement.view-users")}
        </Button>
      </div>
    </div>;
};
const useLiveDataRive = () => {
  const stateMachineName = "State Machine - Live Data";
  const stateMachineInputName = "Data Detected - Transition Trigger";
  const stateMachineArtBoardName = "Live Data";
  const {
    rive,
    RiveComponent
  }: RiveState = useRive({
    src: IMMERSIVE_ASSETS.eventListener,
    stateMachines: [stateMachineName],
    artboard: stateMachineArtBoardName,
    autoplay: true,
    layout: new Layout({
      fit: Fit.Cover,
      alignment: Alignment.Center
    })
  });
  const transitionInput = useStateMachineInput(rive, stateMachineName, stateMachineInputName);
  return {
    RiveComponent,
    transitionInput
  };
};
export const EventListener = _ref => {
  let {
    isIntegrated
  } = _ref;
  const {
    RiveComponent,
    transitionInput
  } = useLiveDataRive();
  React.useEffect(() => {
    if (isIntegrated) {
      transitionInput === null || transitionInput === void 0 || transitionInput.fire();
    }
  }, [isIntegrated, transitionInput]);
  return <div className={clsx(styles.eventListenerContainer, {
    [styles.justifyContentCenter]: !isIntegrated
  })} data-sentry-component="EventListener" data-sentry-source-file="index.tsx">
      {isIntegrated ? <ConnectedContent /> : <ListeningContent />}
      <RiveComponent className={styles.animationBorder} data-sentry-element="RiveComponent" data-sentry-source-file="index.tsx" />
    </div>;
};